<template>
  <v-tooltip location="top">
    <template #activator="{ props }">
      <span class="ai-tag" v-bind="props">
        <v-icon
          icon="mdi-robot-outline"
          size="12"
          class="mr-1"
          style="margin: 0; padding: 0; line-height: 1; width: 12px; min-width: 12px"
        />
        {{ t('aiAssistant.label') }}
      </span>
    </template>
    <span>{{ t('aiAssistant.disclaimer') }}</span>
  </v-tooltip>
</template>

<script>
import { useInternationalization } from '@/composables/use-internationalization';

export default {
  name: 'AiTag',

  setup() {
    const { t } = useInternationalization();
    return { t };
  },
};
</script>

<style lang="scss" scoped>
@import '@style/base/_variables.scss';

.ai-tag {
  background-color: $assortment-secondary-colour;
  color: $rtls-white;
  border-radius: 4px;
  padding: 4px 10px;
  margin: 0 4px;
  font-size: 1rem;
  line-height: 1;
  font-weight: 600;
  display: inline-block;
  vertical-align: middle;
}
</style>
